import { useEffect, useRef, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { callJoinRoomByCode } from "../lib/functions";

export default function JoinByCodePage() {
  const { code } = useParams<{ code: string }>();
  const { user, profile } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const attemptedRef = useRef(false);

  useEffect(() => {
    if (!code || !user || !profile) return;
    if (attemptedRef.current) return;
    attemptedRef.current = true;
    callJoinRoomByCode(code)
      .then(({ roomId }) => navigate(`/room/${roomId}`, { replace: true }))
      .catch(e => setError(e?.message ?? "Couldn't join that room."));
  }, [code, user, profile, navigate]);

  if (!user) return <Navigate to="/" replace />;
  if (!profile) return <Navigate to="/" replace />;

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="bg-white/5 rounded-2xl p-8 max-w-md w-full text-center">
        <h1 className="text-2xl font-bold mb-2">Joining room…</h1>
        <p className="text-white/70 mb-4">Code: <span className="font-mono">{code}</span></p>
        {error && (
          <div>
            <div className="text-red-300 text-sm mb-4">{error}</div>
            <button
              onClick={() => navigate("/", { replace: true })}
              className="px-4 py-2 rounded-lg bg-white text-slate-900 font-semibold"
            >
              Back to home
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
